<!--学生端-消息中心-->
<template>
  <div class="studentMessageCenter">
    <!--左边-->
    <div class="studentMessageCenter-left">
      <!--标题-->
      <Title text="消息中心" class="studentMessageCenter-title"></Title>
      <div class="studentMessageCenter-tabs mat20">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!--系统消息-->
          <el-tab-pane name="system">
            <span slot="label">
              <el-badge :value="MessageReceivesList.count" class="item"><i class="iconfont iconshengyin"></i></el-badge>系统消息</span>
            <el-scrollbar>
              <div
                class="studentMessageCenter-MsgList"
                :class="{ activeList: currentIndex === index }"
                v-for="(value, index) in MessageReceivesList.list"
                :key="index"
                @click="handleCurrentData(value, index)"
              >
                <span :class="{ isRead: value.is_read }">{{value.title}}</span
                ><em>{{value.created_at}}</em>
              </div>
              <el-pagination
                v-if="MessageReceivesList.list.length > 0"
                layout="prev, pager, next"
                @current-change="handleChange"
                :page-size="limit"
                :total="total"
              />
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--右边部分-->
    <div
      class="studentMessageCenter-right"
      :class="{ activeStudent: !Object.keys(currentData).length }"
    >
      <div v-if="Object.keys(currentData).length !== 0">
        <!--右边的标题-->
        <div class="studentMessageCenter-title">
          <!--标题-->
          <span v-if="currentData.title">{{ currentData.title }}</span>
          <span v-if="currentData.question">{{ currentData.question }}</span>
          <!--时间-->
          <em v-if="currentData.created_at">{{currentData.created_at }}</em>
          <em></em>
        </div>
        <!--内容-->
        <div class="studentMessageCenter-content" v-if="currentData.content">
          <div v-html="currentData.content"></div>
        </div>
        <div class="studentMessageCenter-content" v-if="currentData.answer">
          <div v-html="currentData.answer"></div>
        </div>
        <!--<el-button type="primary" @click="handleDelete">删除</el-button>-->
      </div>
      <!-- <Error hint="暂无数据" v-else /> -->
      <ComponentEmpty v-else title="暂无数据" tips=""/>
    </div>
  </div>
</template>

<script>
  import { getStore } from "@/utils/localStorage";
  //  接口
  import {
    getCourseMessage,
    getMessageReceives,
    getClassMessage,
    updateClassMessageRead,
    updateMessageReceivesRead,
    updateCourseMessageRead
  } from "../../../api/messageCenter";
  import {jsToFormData} from "../../../utils/func";

  export default {
    name: "index",
    data() {
      return {
        activeName: "system",
        //  系统消息
        MessageReceivesList: [],
        currentData: {},
        currentIndex: null,
        profession_id: 0,
        page:1,
        limit:10,
        total:0,
        classPage:1,
        classTotal:1,
        coursePage:1,
        courseTotal:0,
      };
    },
    methods: {
      handleChange(val) {
          this.page = val;
          this.getMessageReceivesList();
      },

      getMessageReceivesList(){
        getMessageReceives({'page':this.page,'limit':this.limit}).then((res)=> {
          if(res.code === 200){
            this.MessageReceivesList = res.result;
            this.total = res.result.total;
            //console.log(this.MessageReceivesList)
          }
        });
      },

      //  tabs切换
      handleClick() {
        this.currentIndex = null;
        this.currentData = {};
      },
      //  当前点击的消息
      handleCurrentData(value, index) {
        this.currentIndex = index;
        this.currentData = value
        //console.log(this.currentData)
        if(this.currentData.is_read === 0 ){
          this.currentData.is_read = 1;
          if (this.activeName === "system") {
            this.MessageReceivesList.count = this.MessageReceivesList.count-1;
            updateMessageReceivesRead(jsToFormData({"id":value.id})).then((r) => {

            });
          }
        }

      },
    },

    created() {

      let majorStore = getStore("studentMajor");
      if (majorStore) {
        this.profession_id = JSON.parse(majorStore).profession_id;
      }
      this.handleChange(1);
    },
  };
</script>

<style lang="scss" scoped>
  .studentMessageCenter {
    margin: 20px;
    /*display: flex;*/
    height: 100%;

    /deep/ img {
      width: 50%;
    }

    .el-scrollbar {
      height: 100%;
      margin-right: 20px;
      // padding-right: 20px;

      /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }

    /*左边*/
    .studentMessageCenter-left {
      /*flex: 4;*/
      background-color: #ffffff;
      padding-left: 20px;
      height: 100%;
      border-radius: 5px;
      width: 38.5%;
      float: left;

      .studentMessageCenter-title {
        height: 50px;
      }

      .studentMessageCenter-tabs {
        height: 90%;

        .el-tabs {
          height: 90%;

          /deep/ .el-tabs__header {
            margin: 0;
          }

          /deep/ .el-tabs__content {
            height: 100%;

            .el-tab-pane {
              height: 100%;
            }
          }

          //  消息列表
          .studentMessageCenter-MsgList {
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            border-bottom: 1px solid #efefef;
            cursor: pointer;

            &:hover {
              background-color: #f6faff;
            }

            .isRead {
              color: #9a9a9a;
            }
          }

          .activeList {
            background-color: #f6faff;
          }

          //  消息回复列表
          .studentMessageCenter-replyList {
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 20px;
            border-bottom: 1px solid #efefef;
            cursor: pointer;

            i {
              @include fontColor("primary");
            }

            &:hover {
              background-color: #f6faff;
            }
          }

          span {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            color: #343434;
          }

          em {
            // flex: 3;
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            color: #9a9a9a;
          }
        }

        /deep/ .el-badge__content.is-fixed {
          right: -50px;
        }

        /deep/ .el-tabs__nav-scroll {
          padding: 10px 0 0 0;
        }

        i {
          margin-right: 5px;
          @include fontColor("primary");
        }
      }
    }

    /*右边*/
    .studentMessageCenter-right {
      /*flex: 6;*/
      /*margin-left: 20px;*/
      padding-bottom: 20px;
      background-color: #ffffff;
      border-radius: 5px;
      position: relative;
      width: 60%;
      float: right;
      /*height: 150vh;*/

      .studentMessageCenter-title {
        height: 128px;
        border-bottom: 1px solid #eaeef7;
        padding: 0 40px 20px 40px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        span {
          flex: 8;
          font-weight: 400;
          font-size: 21px;
          color: #343434;
        }

        em {
          flex: 2;
          font-size: 13px;
          font-weight: 300;
          color: #666666;
          text-align: right;
        }
      }

      .studentMessageCenter-content {
        width: 100%;
        height: 70%;
        margin-top: 40px;
        padding: 0 40px;
        text-indent: 2em;
        word-break: break-all;
        font-weight: 300;
        font-size: 14px;
        color: #808080;
        margin-bottom: 80px;
      }

      .el-button {
        /*float: right;*/
        /*margin-right: 40px;*/
        /*margin-top: 10px;*/
        height: 30px;
        line-height: 0;
        position: absolute;
        bottom: 40px;
        right: 40px;
      }
    }

    .activeStudent {
      height: 100%;
    }
  }
</style>
